/** @type {import('../schema').ProcessDefinition} */
const empleadosChat = {
  id: "empleados-chat",
  name: "Chat interno admin–empleado",
  category: "comunicaciones",
  outcome:
    "Comunicación bidireccional en tiempo real entre el empleado y la administración (texto y audio).",
  trigger: "El Empleado abre el chat, o el Admin lo selecciona desde su bandeja.",
  actors: ["Empleado", "Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Chat interno (employee_chats + employee_chat_messages) entre empleado y admin, con mensajes de texto o audio (con transcripción), entrega en tiempo real, recibos de lectura y contadores de no leídos por lado.",
  lanes: [
    { id: "emp", actor: "Empleado" },
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    { id: "s1", laneId: "emp", type: "start", label: "Abre el chat con el admin", description: "Desde su panel de empleado.", evidence: "src/screens/employee/ChatEmployee.jsx" },
    { id: "s2", laneId: "sys", type: "task", label: "Crea/recupera la sesión", description: "Busca o crea el documento employee_chats (lazy)." },
    { id: "s3", laneId: "emp", type: "decision", label: "¿Texto o audio?" },
    { id: "s4", laneId: "emp", type: "task", label: "Envía un mensaje de texto" },
    { id: "s5", laneId: "emp", type: "task", label: "Graba y envía un audio", description: "Audio con transcripción (type: audio)." },
    { id: "s6", laneId: "admin", type: "notification", label: "Recibe en tiempo real", description: "El admin lo ve en su bandeja de chats.", evidence: "src/screens/admin/ChatAdmin.jsx:47" },
    { id: "s7", laneId: "admin", type: "task", label: "Responde" },
    { id: "s8", laneId: "sys", type: "task", label: "Marca leído y actualiza contadores", description: "read: true + unreadCount por lado al abrir la conversación." },
    { id: "s9", laneId: "emp", type: "end", label: "Conversación al día" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "texto" },
    { from: "s3", to: "s5", label: "audio" },
    { from: "s4", to: "s6" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9" },
  ],
};

export default empleadosChat;
